var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVerifyFactor4X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.9099C18.6274 24.9099 24 19.5373 24 12.9099C24 6.28248 18.6274 0.9099 12 0.9099C5.37258 0.9099 0 6.28248 0 12.9099C0 19.5373 5.37258 24.9099 12 24.9099Z",
    fill: "#93C5FD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.6156 12.5179L9.8636 10.5979H11.7116L9.5516 13.6339C10.0316 14.2339 10.4676 14.8179 10.8596 15.3859C11.2516 15.9539 11.5636 16.4619 11.7956 16.9099H9.8756C9.8116 16.7899 9.7316 16.6419 9.6356 16.4659C9.5396 16.2819 9.4316 16.0939 9.3116 15.9019C9.1916 15.7019 9.0636 15.5059 8.9276 15.3139C8.7996 15.1139 8.6716 14.9339 8.5436 14.7739C8.4236 14.9259 8.2996 15.0939 8.1716 15.2779C8.0516 15.4619 7.9356 15.6499 7.8236 15.8419C7.7116 16.0259 7.5996 16.2099 7.4876 16.3939C7.3836 16.5779 7.2916 16.7499 7.2116 16.9099H5.3876C5.4836 16.7099 5.6156 16.4739 5.7836 16.2019C5.9516 15.9299 6.1316 15.6499 6.3236 15.3619C6.5236 15.0659 6.7316 14.7739 6.9476 14.4859C7.1636 14.1899 7.3756 13.9139 7.5836 13.6579C7.2236 13.1539 6.8636 12.6459 6.5036 12.1339C6.1436 11.6139 5.7876 11.1019 5.4356 10.5979H7.3676L8.6156 12.5179ZM15.7401 10.7779C15.4281 11.1859 15.0961 11.6299 14.7441 12.1099C14.3921 12.5899 14.0961 13.0819 13.8561 13.5859H15.7401V10.7779ZM17.4921 8.5939V13.5859H18.3801V15.0499H17.4921V16.9099H15.7401V15.0499H12.1521V13.7419C12.3281 13.3899 12.5481 12.9939 12.8121 12.5539C13.0761 12.1059 13.3681 11.6499 13.6881 11.1859C14.0161 10.7139 14.3601 10.2539 14.7201 9.8059C15.0801 9.3579 15.4401 8.9539 15.8001 8.5939H17.4921Z",
    fill: "#2D3344"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerifyFactor4X);
export default __webpack_public_path__ + "static/media/not_verify_factor4x.752f73076d3f60558ffb5bd6308ae473.svg";
export { ForwardRef as ReactComponent };